import { useParams } from 'react-router-dom';

import { ErrorContent } from 'components/FetchingErrorBoundary';
import Loading from 'components/Icons/Loading';
import { useCertificateQuery } from 'hooks/useCertificateQuery';
import { CATEGORY_TYPE } from 'models/documents.model';

import BatteryCellsReceivingConfirmation from './BatteryCellsReceivingConfirmation/BatteryCellsReceivingConfirmation';
import BatteryCellsShippingConfirmation from './BatteryCellsShippingConfirmation';
import BatteryCellsTestResults from './BatteryCellsTestResults';
import BatteryPacksTestResults from './BatteryPacksTestResults';
import CarDealersShippingConfirmation from './CarDealersShippingConfirmation';
import ChemistryTestResults from './ChemistryTestResults';

const PrivateDocumentDetails = () => {
  const { id } = useParams();

  const {
    data: document,
    isLoading,
    refetch,
  } = useCertificateQuery(id ?? '', {
    useErrorBoundary: true,
  });

  if (isLoading) return <Loading />;

  if (!document) return <ErrorContent onRetry={refetch} />;

  switch (document.category) {
    case CATEGORY_TYPE.CHEMISTRY:
    default:
      return <ChemistryTestResults {...document} />;
    case CATEGORY_TYPE.BATTERY_CELLS_TEST_RESULTS:
      return <BatteryCellsTestResults {...document} />;
    case CATEGORY_TYPE.BATTERY_PACKS_TEST_RESULTS:
      return <BatteryPacksTestResults {...document} />;
    case CATEGORY_TYPE.BATTERY_CELLS_SHIPPING_CONFIRMATION:
      return <BatteryCellsShippingConfirmation {...document} />;
    case CATEGORY_TYPE.BATTERY_CELLS_RECEIVING_CONFIRMATION:
      return <BatteryCellsReceivingConfirmation {...document} />;
    case CATEGORY_TYPE.CAR_DEALERS_SHIPPING_CONFIRMATION:
      return <CarDealersShippingConfirmation {...document} />;
  }
};

export default PrivateDocumentDetails;
